import { FieldSpecRepeater } from "../spec-repeater/FieldSpecRepeater";
import {useEffect, useState} from "react";

const EarningEventFields = props => {

  const [fields, setFields] = useState(props.value || []);
  useEffect(() => props.onChange ? props.onChange(fields) : null, [fields])

  return (
    <>
      <div className="tgbl-cred-user-relationship-fields tgbl-field-block">
        <div className="tf-pseudo-description" >Define fields that will appear on the Earned Accreditation</div>
        <FieldSpecRepeater
          name={'accreditation_fields'}
          value={fields}
          onChange={props.onChange}
        />
      </div>
    </>
  )
}

export { EarningEventFields }
